import { extends as _extends } from '../../../../_virtual/_rollupPluginBabelHelpers.js';
import { DO_NOT_USE_FaWrapper } from '../../../foundation/falcon/do-not-use-fa-wrapper/index.js';
import { faEllipsis } from '@fortawesome/pro-regular-svg-icons/faEllipsis';
import { useState, Children, isValidElement } from 'react';
import { Container } from '../styled.js';
import { StyledIconButton } from './styled.js';
import { jsxs, jsx } from 'react/jsx-runtime';
import { Menu } from '../../Menu/Menu.js';
import { MenuBody } from '../../Menu/MenuBody.js';
import { MenuList, MenuItem } from '../../Menu/styled.js';

var __rest = undefined && undefined.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
var OFFSET = 2;
function BreadcrumbMenu(props) {
  var children = props.children;
  var _useState = useState(false),
    open = _useState[0],
    setOpen = _useState[1];
  var items = Children.toArray(children);
  var first = items.slice(0, OFFSET);
  var middle = items.slice(OFFSET, items.length - OFFSET);
  var last = items.slice(Math.max(items.length - OFFSET, 1));
  var closeMenu = function closeMenu() {
    return setOpen(false);
  };
  var toggleMenu = function toggleMenu() {
    return setOpen(!open);
  };
  var renderMenuListItem = function renderMenuListItem(child) {
    if ( /*#__PURE__*/isValidElement(child)) {
      var _a = child.props,
        childContent = _a.children,
        restProps = __rest(_a, ["children"]);
      return /*#__PURE__*/jsx(MenuItem, _extends({}, restProps, {
        children: childContent
      }), child.key);
    }
    return null;
  };
  return /*#__PURE__*/jsxs(Container, {
    children: [first, /*#__PURE__*/jsx(Menu, {
      open: open,
      onClose: closeMenu,
      target: /*#__PURE__*/jsx(StyledIconButton, {
        size: "xs",
        appearance: "ghost",
        onClick: toggleMenu,
        children: /*#__PURE__*/jsx(DO_NOT_USE_FaWrapper, {
          icon: faEllipsis
        })
      }),
      children: /*#__PURE__*/jsx(MenuBody, {
        children: /*#__PURE__*/jsx(MenuList, {
          children: Children.map(middle, renderMenuListItem)
        })
      })
    }), last]
  });
}

export { BreadcrumbMenu };
